import { useMemo } from 'react';
import { CAN_USE_DOM } from 'src/constants/other';

export interface Viewport {
  height: number;
  width: number;
  vw: (value: number) => number;
  vh: (value: number) => number;
}

export function useViewport(): Viewport {
  return useMemo(() => {
    const height = CAN_USE_DOM ? window.innerHeight : 0;
    const width = CAN_USE_DOM ? window.innerWidth : 0;

    const viewport = {
      height,
      width: width > 414 ? 414 : width,
    };

    return {
      ...viewport,
      vw: (value: number) => Math.round(viewport.width * value),
      vh: (value: number) => Math.round(viewport.height * value),
    };
  }, []);
}
